<script setup lang="ts">
// TODO Fu**ing error-prune narrowing type to any between Hotel and Bundle Packages should be fixed ASAP
import HotelCardSection from './HotelCardSection.vue';
import BundleCard from '@components/ui/hotelPage&view/cards/bundle/BundleCard.vue';
import type BundlePackage from '@itinerary/bundle/BundlePackage';

interface IProps {
    list?: BundlePackage[];
    displayBanners?: boolean;
    showMap?: boolean;
}
const { list = [], showMap, displayBanners } = defineProps<IProps>();
const emit = defineEmits<{
    reserve: [item: BundlePackage, index: number];
    viewSection: [];
    closeMap: [];
}>();
const hotelPackagesList = computed(() => list.map(b => b.hotelPackage));
</script>

<template>
    <HotelCardSection
        :display-banners
        :list="list as any"
        :map-hotel-list="hotelPackagesList"
        :show-map
        @view-section="emit('viewSection')"
        @close-map="emit('closeMap')"
    >
        <template
            #card="{ item, hoveredHotelId, onHoverCard, index, clearHovered }"
        >
            <BundleCard
                :bundle-package="list[index]"
                :mobile-view="showMap"
                :class="{
                    hovered: showMap && item && hoveredHotelId === item.id,
                    'other-hovered':
                        showMap &&
                        item &&
                        hoveredHotelId !== null &&
                        hoveredHotelId !== item.id,
                }"
                mobile-observing
                @mouseenter="onHoverCard(item)"
                @mouseleave="clearHovered"
                @intersect="onHoverCard(item)"
                @reserve="emit('reserve', item as any, index)"
            />
        </template>
    </HotelCardSection>
</template>
